app.controller('MenuTopController', ['$rootScope', '$scope', '$state', function ($rootScope, $scope, $state) {

    $scope.menu_view_model = {
        is_order_quote_mode_visible: false,
        is_account_options_visible: false
    }

    $scope.orderQuoteModeOptionSelected = function (optionID) {
        switch (optionID) {
            case "save_current":
                $rootScope.service.order.saveOrder();
                break;
            case "new_order":
                startNewOrder();
                break;
            case "new_quote":
                startNewOrder(true);
                break;
            default:
                break;
        }
        $scope.menu_view_model.is_order_quote_mode_visible = false;
    }

    $scope.accountOptionSelected = function (optionID) {
        switch (optionID) {
            case "my_account":
                $state.go('myba.account');
                break;
            case "toggleDevMode":
                toggleDevMode();
                break;
            case "logout":
                $rootScope.service.tracking.track_event("Login status", "Log out");
                window.location = "/logout.php"
                break;
            default:
                break;
        }
        $scope.menu_view_model.is_account_options_visible = false;
    }

    function startNewOrder(isQuote) {
        if(!isQuote){
            $rootScope.service.tracking.track_event("Order", "Started new order");
        } else {
            $rootScope.service.tracking.track_event("Quote", "Started new quote");
        }
        $rootScope.service.order.startNewOrder(isQuote);
        $state.go('myba.dashboard');
    }

    function toggleDevMode() {
        $rootScope.model.cache_settings.settings.dev_mode = !$rootScope.model.cache_settings.settings.dev_mode;
        $rootScope.service.cache_settings.saveSettings();
    }

    $rootScope.$on('document_click', function ($event, $params) {
        $scope.menu_view_model.is_order_quote_mode_visible = false;
        $scope.menu_view_model.is_account_options_visible = false;
    });

    $rootScope.onOrderQuoteModeClick = function ($event) {
        $event.stopPropagation();
    };

    $rootScope.onAccountOptionsClick = function ($event) {
        $event.stopPropagation();
    };
}]);